import React from "react";
import mobileLogo from "../../assets/icons/mobileLogo.svg";

const MobileLogo = () => {
  return <img src={mobileLogo} alt="" className="w-[40px] -mt-4" />;
};

export default MobileLogo;
